import SearchPage, {
  getServerSideProps as getSearchPageServerSideProps,
} from "@/pages/search";
import { getSearchPinsByQingzhou } from "@/services";
import { getKeyWordInfo, getSeoInlinks } from "@/services/qingzhou";
import { serverSideNotFound } from "@/utils/server/serverSide";
import Head from "next/head";

export async function getServerSideProps(props) {
  const { req, params } = props;
  const { keyword } = params;

  try {
    const info = await getKeyWordInfo({
      keyword,
      category_code: "topic-material",
    });

    const searchWord = info?.keyword;

    if (!searchWord) {
      return serverSideNotFound(props.res);
    }

    const [searchPageResult, result, inlinks] = await Promise.all([
      getSearchPageServerSideProps({ ...props, path: "topic-material" }),
      getSearchPinsByQingzhou({
        text: searchWord,
        page: 1,
        limit: 20,
        material: true,
        all_match: false,
      }),
      getSeoInlinks({
        title: `${searchWord}_${searchWord}素材下载_图片视频素材-花瓣网`,
        current_url: req.url,
      }),
    ]);

    return {
      props: {
        searchWord,
        inlinks,
        serverSideMaterialFilters:
          searchPageResult?.props?.serverSideMaterialFilters || [],
        searchResult: result.pins || [],
      },
    };
  } catch (error) {
    return serverSideNotFound(props.res);
  }
}

export default function Index({
  searchWord,
  searchResult,
  serverSideMaterialFilters,
}) {
  return (
    <>
      <SearchPage
        query={{ type: "material", q: searchWord }}
        searchResult={searchResult}
        serverSideMaterialFilters={serverSideMaterialFilters}
        pageInfo={{
          title: searchWord + "素材",
          desc: `${searchWord}素材资源，发现${searchWord}相关素材资源，一键收藏免费下载。花瓣网，设计师灵感库，素材图库分发。`,
        }}
      />
      <Head>
        <title>{`${searchWord}_${searchWord}素材下载_图片视频素材-花瓣网`}</title>
        <meta
          name="keywords"
          content={`${searchWord},${searchWord}素材,${searchWord}视频`}
        ></meta>
        <meta
          name="description"
          content={`花瓣网为你提供${searchWord}相关素材资源，海量${searchWord}相关图片素材、视频素材供您选择。花瓣网, 设计师寻找灵感的天堂！更多${searchWord}相关图片、素材、设计灵感尽在花瓣网。`}
        ></meta>
      </Head>
    </>
  );
}
